import { useAuthStore } from '@/store'
import { TestRollbackButton } from '@/components/email/TestRollbackButton'
import { LoadingSpinner } from '@/components/common'
import { PlatformBoard } from '@/components/superadmin/PlatformBoard'
import { useSuperadminBoard } from '@/hooks/useSuperadminBoard'

export function SuperadminDashboardPage() {
  const { user } = useAuthStore()
  const { board, loading, error, moving, reload, moveCard } = useSuperadminBoard()

  const displayName = user?.first_name || user?.last_name
    ? `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim()
    : user?.email ?? 'Unbekannt'

  if (loading && !board) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
      <TestRollbackButton />
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">{displayName}</h1>
        <p className="mt-1 text-gray-500">Offene Plattform-Arbeit</p>
      </div>

      {error && (
        <div className="mb-4 p-3 bg-yellow-100 border border-yellow-200 text-yellow-700 rounded text-sm flex items-center justify-between">
          <span>{error}</span>
          <button type="button" onClick={() => void reload()} className="underline hover:text-yellow-900 ml-4 shrink-0">
            Erneut versuchen
          </button>
        </div>
      )}

      {board && board.errors.length > 0 && (
        <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 text-yellow-800 rounded text-sm">
          Einzelne Werte fehlen ({board.errors.join(', ')}). Das Board bleibt nutzbar.
        </div>
      )}

      {board && (
        <PlatformBoard board={board} moving={moving} onMove={moveCard} />
      )}
    </div>
  )
}
